import Card from '@/components/Card';
import { useNavigate } from 'react-router-dom';
import { TFunction } from 'i18next';
import { AuthButton } from '@/components/Custom/Button/AuthButton';

interface ForgotPasswordEmailReceiptProps {
  t?: TFunction<'unknown'>;
  email: string;
  setEmail: (email: string) => void;
}

export const ForgotPasswordEmailReceipt = ({
  t,
  email,
  setEmail,
}: ForgotPasswordEmailReceiptProps) => {
  const navigate = useNavigate();

  const handleRedirectToLogin = () => {
    setEmail('');
    navigate('/login');
  };

  const handleRedirectToPreviousPage = () => {
    setEmail('');
    navigate('/forgot-password');
  };

  return (
    <div className="flex justify-center">
      <Card
        cardClassName="max-w-[440px] max-sm:w-full"
        bodyClassName="px-10 pt-16 pb-20"
      >
        <div className="flex justify-center">
          <img
            alt="image"
            className="dark:hidden max-h-[130px]"
            src="media/illustrations/30.svg"
          />
          <img
            alt="image"
            className="light:hidden max-h-[130px]"
            src="media/illustrations/30-dark.svg"
          />
        </div>
        <h3 className="text-[25px] font-bold text-gray-900 text-center mb-5.5">
          {t('checkYourEmail')}
        </h3>
        <div className="text-md leading-[22px] text-gray-600 text-center">
          {t('emailSentToYourEmailAddress')}{' '}
          <a
            className="text-md text-gray-800 font-medium hover:text-primary-active"
            href="#"
          >
            {email}
          </a>{' '}
          {`${t('toResetYourPassword').toLowerCase()}.`}
        </div>
        <div className="mt-5 text-md text-gray-600 text-center">
          {t('thankYouForYourAttention')}
        </div>
        <div className="mt-7.5 w-full">
          <AuthButton text={t('logIn')} onClick={handleRedirectToLogin} />
        </div>
        <div className="mt-5 flex items-center justify-center gap-1">
          <span className="text-sm font-medium text-gray-600">
            {`${t('didNotReceiveAnEmail')} ?`}
          </span>
          <div
            className="text-sm font-medium text-primary underline hover:cursor-pointer"
            onClick={handleRedirectToPreviousPage}
          >
            {t('resend')}
          </div>
        </div>
      </Card>
    </div>
  );
};
